import { render, staticRenderFns } from "./Phrase.vue?vue&type=template&id=bfff4588&scoped=true&"
import script from "./Phrase.vue?vue&type=script&lang=js&"
export * from "./Phrase.vue?vue&type=script&lang=js&"
import style0 from "./Phrase.vue?vue&type=style&index=0&id=bfff4588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff4588",
  null
  
)

export default component.exports